import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const PinMap_md = (props) => {
    const width = props.width ? props.width + 'px' : '24px';
    const height = props.height ? props.height + 'px' : '24px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 24 24"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 1.96652L15 3.53174L18.2427 2.68581C20.1435 2.18996 22 3.6243 22 5.58866V17.8896C22 19.2548 21.0783 20.4478 19.7573 20.7924L15 22.0335L9 20.4682L5.75726 21.3142C3.85651 21.81 2 20.3757 2 18.4113V6.1104C2 4.7452 2.92174 3.55215 4.24273 3.20755L9 1.96652ZM10 18.6622L14 19.7057V5.3378L10 4.29432V18.6622ZM8 4.29432V18.6622L5.25242 19.3789C4.61884 19.5442 4 19.0661 4 18.4113V6.1104C4 5.65533 4.30725 5.25765 4.74758 5.14278L8 4.29432ZM16 5.3378V19.7057L19.2524 18.8572C19.6928 18.7423 20 18.3446 20 17.8896V5.58866C20 4.93387 19.3812 4.45576 18.7476 4.62104L16 5.3378Z"
            />
        </SvgStyled>
    );
};

export default PinMap_md;
